import React, { forwardRef, useRef } from 'react'
import { Body, Box, H4 } from '../layout'
import { useGSAP } from '@gsap/react'
import gsap from "gsap"

export const Point = forwardRef(function Point({ height = 100, children }, ref) {
  const lineRef = useRef()
  const containerRef = useRef()

  useGSAP(() => {
    const container = containerRef.current
    const line = lineRef.current

    if (!container || !line) return

    gsap.fromTo(
      line,
      { height: 0 },
      {
        height: height,
        ease: "none",
        scrollTrigger: {
          trigger: container,
          start: "top center",
          end: "bottom center",
          scrub: true,
        }
      }
    )
  }, [])


  return (
    <Box gap={24} ref={ref}>
      <Box column gap={20} px={14} py={10} justifyContent="center" alignItems="center">
        <Box size={24} background="white" r="50%" />
        <Box container height={height} width={4} ref={containerRef}>
          <Box ref={lineRef} position="absolute" top={0} left={0} width={4} zIndex={2} r={100} background="white" maxHeight={height} />
          <Box position="absolute" top={0} left={0} width={4} height={height} background="#212121" r={100} />
        </Box>
      </Box>
      {children}
    </Box>
  )
})